import React, { useEffect, useState } from 'react';
import GraphButton from '../../../GraphButton';
import {
  clearSelection,
  getNode,
  lDagreVisible,
  onBtnHide,
  onBtnShow,
  onBtnShowAll,
  removeNode,
} from '../../scripts/cy-core';
import { useSelector } from 'react-redux';

const SelectingControl = () => {
  const currentNode = useSelector((state) => state.tree.currentNode);
  const treeData = useSelector((state) => state.tree.treeData);
  let [currentNodeVisible, setCurrentNodeVisible] = useState(true);

  const onClickBtnHide = () => {
    if (currentNodeVisible) {
      onBtnHide();
    } else {
      onBtnShow();
    }
    setCurrentNodeVisible(!currentNodeVisible);
  };

  useEffect(() => {
    const node = getNode();
    // // debug-console.log('[Use Effect] node=', node);
    if (node) {
      // // debug-console.log('SetCurrentNodeVisible=', !node.hasClass('hide'));
      setCurrentNodeVisible(!node.hasClass('hide'));
    } else {
      // // debug-console.log('Default SetCurrentNodeVisible=true');
      setCurrentNodeVisible(true);
    }
  }, [currentNode, treeData]);
  return (
    <div id="selecting">
      <div id="selecting-buttons">
        <GraphButton
          id="btnArrange"
          label="Sắp xếp"
          onClick={() => lDagreVisible()}
          title="Sắp xếp lại theo hàng"
        />
        <GraphButton
          id="btnShowAll"
          label="Hiện tất cả"
          onClick={onBtnShowAll}
          title="Hiển thị cả những người đã ẩn"
        />
        <GraphButton
          id="btnHide"
          label={currentNodeVisible ? 'Ẩn' : 'Hiện'}
          onClick={onClickBtnHide}
          title="Ẩn những người đang chọn (Không làm thay đổi dữ liệu, có thể hiển thị lại khi ấn Hiển thị tất cả)"
        />
        <GraphButton
          id="btnClearSelection"
          label="Bỏ chọn"
          onClick={clearSelection}
          title="Bỏ chọn hết tất cả những người đang chọn"
        />
        <GraphButton
          id="btnRemove"
          label="Xóa"
          onClick={() => removeNode(currentNode.id)}
          title="Xóa người đang chọn"
        />
      </div>
      {/* <ShapeBtn /> */}
    </div>
  );
};

export default SelectingControl;
